import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.CSelect, _vm.classes]
  }, [_vm._t("label", function () {
    return [_vm.label ? _c('span', {
      class: _vm.$style.label
    }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]) : _vm._e()];
  }, {
    "label": _vm.label
  }), _vm._v(" "), _c('Multiselect', _vm._g(_vm._b({
    attrs: {
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.changeValue
    },
    scopedSlots: _vm._u([{
      key: "caret",
      fn: function fn(_ref) {
        var toggle = _ref.toggle;
        return [_c('span', {
          staticClass: "multiselect__dropdown"
        }, [_c('SIcon', {
          staticStyle: {
            "align-self": "center"
          },
          attrs: {
            "icon": "chevron-down-filled",
            "size": "24"
          },
          nativeOn: {
            "mousedown": function mousedown($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return toggle.apply(null, arguments);
            }
          }
        })], 1)];
      }
    }, {
      key: "noOptions",
      fn: function fn() {
        return [_vm._t("empty", function () {
          return [_vm._v("\n        " + _vm._s(_vm.empty) + "\n      ")];
        }, {
          "empty": _vm.empty
        })];
      },
      proxy: true
    }, {
      key: "option",
      fn: function fn(_ref2) {
        var option = _ref2.option;
        return [_vm._t("option", function () {
          return [_vm.bind.multiple ? _c('span', [_vm._v("\n          " + _vm._s(option.label) + " multiple " + _vm._s(_vm.active(option)) + "\n        ")]) : _c('span', {
            staticClass: "selected"
          }, [_vm._v("\n          " + _vm._s(option.label) + "\n          "), _c('span', {
            staticClass: "chosen"
          }, [_c('SIcon', {
            attrs: {
              "icon": "check",
              "size": "20"
            }
          })], 1)])];
        })];
      }
    }, {
      key: "singleLabel",
      fn: function fn(_ref3) {
        var option = _ref3.option;
        return [_vm._t("selected-option", function () {
          return [_vm._v("\n        " + _vm._s(option.label) + "\n      ")];
        })];
      }
    }, {
      key: "tag",
      fn: function fn(_ref4) {
        var option = _ref4.option;
        return [_vm._t("selected-option", function () {
          return [_vm._v("\n        " + _vm._s(option.label) + "\n      ")];
        })];
      }
    }, {
      key: "selection",
      fn: function fn(_ref5) {
        var values = _ref5.values;
        return [_vm._t("selected-option-container", function () {
          return [values.length > 1 ? _c('span', [_vm._v("\n          " + _vm._s(values[0].label) + " и еще " + _vm._s(values.length - 1) + "\n        ")]) : _vm._e()];
        })];
      }
    }], null, true)
  }, 'Multiselect', _vm.bind, false), _vm.$listeners)), _vm._v(" "), _vm._t("hint", function () {
    return [_vm._v("\n    " + _vm._s(_vm.hint) + "\n  ")];
  }, {
    "hint": _vm.hint
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };